// DrawerLink component for proper navigation with debugging
import React from 'react';
import { useNavigate } from 'react-router-dom';

const DrawerLink = ({ label, href, onNavigate, section, itemKey }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Handle normal navigation
    console.log(`[FacilityConsole] nav ${href}`);
    if (!href) return console.warn('[FacilityConsole] missing href', { label, itemKey });
    
    // Navigate first, then close drawer after navigation completes
    Promise.resolve(navigate(href)).then(() => {
      onNavigate?.();
    });
  };

  const handleMouseEnter = () => {
    console.debug('[FacilityConsole] item hover', { 
      key: itemKey, 
      label,
      href,
      section 
    });
  };

  return (
    <a
      href={href || '#'}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      className="facility-menu-item"
      style={{ pointerEvents: href ? 'auto' : 'none' }}
      data-test="facility-drawer-link"
    >
      {label}
    </a>
  );
};

export default DrawerLink;